import { Fragment } from "react";

/** `idPrefix` should be unique per call site (RichText passes its translationKey) so ids never collide across the page. */
export function parseRichMessage(message: string, idPrefix: string): React.ReactNode {
  const parts = message.split(/(<br><\/br>|<br\s*\/>|<strong>[\s\S]*?<\/strong>|<em>[\s\S]*?<\/em>)/g);
  return parts.map((part, i) => {
    if (part === "<br></br>" || /^<br\s*\/>$/.test(part)) {
      return <br key={i} id={`${idPrefix}-br-${i}`} />;
    }
    const strongMatch = part.match(/^<strong>([\s\S]*?)<\/strong>$/);
    if (strongMatch) {
      return <strong key={i} id={`${idPrefix}-strong-${i}`}>{strongMatch[1]}</strong>;
    }
    const emMatch = part.match(/^<em>([\s\S]*?)<\/em>$/);
    if (emMatch) {
      return <em key={i} id={`${idPrefix}-em-${i}`} className="rich-text-em">{emMatch[1]}</em>;
    }
    return <Fragment key={i}>{part}</Fragment>;
  });
}
